<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{$t('feedback.xp')}}</h1>
          <h2 class="page-subtitle">{{ totalCount }} {{ totalCount === 1 ? $t('feedback') : $t('feedbacks')}}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableFeedback"
          identifier="B122TableFeedback"
          get-b122-table-results-url="/feedback/getB122TableResults"
          :fields="tableFields"
          :empty-title="$t('feedback.emptyTitle').toString()"
          :empty-text="$t('feedback.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn">

          <template #cell(type)="data">
            <div>{{feedbackTrad(data.item.type) }}</div>
          </template>

          <template #cell(creationDate)="data">
            <div>{{ new Date(data.item.creationDate) | moment("Do MMMM YYYY") }}</div>
          </template>

          <template #cell(farmer)="data">
            <div class="textual-link" @click="goToFarmer(data.item.farmer.id )">
              {{ data.item.farmer.tostring }}
            </div>
          </template>
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedItem"
      controllerName="feedback"
      itemSingularName="feedback"
      itemSingularNameUpp="Feedback"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
export default {

  name: 'FeedbackIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data () {
    return {
      totalCount: 0,
      selectedItem: null
    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('Feedback.farmer'),
          key: 'farmer',
          sortable: true
        },
        {
          label: this.$i18n.t('Feedback.date'),
          key: 'creationDate',
          sortable: true
        },
        {
          label: this.$i18n.t('Feedback.type'),
          key: 'type',
          sortable: true
        }
      ]
    }

  },

  methods: {

    feedbackTrad (value) {
      return this.$i18n.t(value)
    },

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'FeedbackShow',
        params: {
          feedbackId: row.item.id
        }
      })
    },

    goToFarmer (id) {
      this.$router.push({
        name: 'FarmerShow',
        params: {
          farmerId: id
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/feedback/FeedbackIndex.vue